import {
  Component, ElementRef, EventEmitter, Input, AfterViewInit, Output, QueryList, ViewChild,
  ViewChildren
} from '@angular/core';
import { MatDialog, PageEvent } from '@angular/material';

import { AirportSearchResult } from '../../airport/models/airport-search-result.model';
import { State } from '../../shared/state-view/state.model';
import { SatPopover } from '@ncstate/sat-popover';
import { SearchQuery } from '../models/search-query.model';
import { AirportFilterListComponent } from '../airport-filter-list/airport-filter-list.component';
import { ShowDialogComponent } from '../../shared/show-dialog/show-dialog.component';


@Component({
  selector: 'app-airport-results-listing',
  templateUrl: './airport-results-listing.component.html',
  styleUrls: ['./airport-results-listing.component.scss']
})
export class AirportResultsListingComponent implements AfterViewInit {
  @Input() pageIndex = 0;
  @Input() pageSize = 10;
  @Input() totalAirports = 0;
  @Input() query: SearchQuery;
  @Input() airports: Array<AirportSearchResult>;
  @Input() state: State = State.Empty;
  @Input() activeAirport: AirportSearchResult;
  @Input() errorMessage: string;
  @Output() pageChanged = new EventEmitter<PageEvent>();
  @Output() airportMouseEnter = new EventEmitter<AirportSearchResult>();
  @Output() airportMouseLeave = new EventEmitter<AirportSearchResult>();
  @Output() filtersChanged = new EventEmitter<SearchQuery>();
  @Output() publicUseChanged = new EventEmitter<void>();
  @Output() fuelPriceToggleChanged = new EventEmitter<void>();

  numAirportFiltersSelected = 0;
  showPrices = false;

  @ViewChild('listEl') listEl: ElementRef;
  @ViewChildren('airportEl', { read: ElementRef }) airportEls: QueryList<ElementRef>;
  @ViewChild('airportFilters') airportFilters: AirportFilterListComponent;
  @ViewChild('airportFiltersPopover') airportFiltersPopover: SatPopover;

  constructor(private _matDialog: MatDialog) {
  }

  ngAfterViewInit() {
    // this.numAirportFiltersSelected = this.airportFilters.getNumSelected();
  }

  onNumAirportFiltersSelectedChanged(numSelected: number) {
    this.numAirportFiltersSelected = numSelected;
  }

  onAirportHover(airport: AirportSearchResult, hover: boolean) {
    if (hover) {
      this.airportMouseEnter.emit(airport);
    } else {
      this.airportMouseLeave.emit(airport);
    }
  }

  /**
   * Returns a jQuery element container for the given airport.
   */
  getAirportEl(airport: AirportSearchResult) {
    const i = this.airports.indexOf(airport);
    if (i < 0) {
      return null;
    }
    const el = this.airportEls.toArray()[i];
    // @ts-ignore
    return $(el.nativeElement);
  }

  /**
   * Scrolls the airports list to the specified airport, marking it as selected.
   */
  public scrollToAirport(airport: AirportSearchResult) {
    if (!this.listEl) {
      return;
    }
    // @ts-ignore
    const $containerEl = $(this.listEl.nativeElement);
    const $el = this.getAirportEl(airport);
    if (!$el) {
      return;
    }
    const position = $el[0].offsetTop;
    $containerEl.stop(true);
    $containerEl.animate({ scrollTop: position }, 500);
  }

  onPageChanged(e: PageEvent) {
    this.pageChanged.emit(e);
    if (!this.listEl) {
      return;
    }
    // @ts-ignore
    const $containerEl = $(this.listEl.nativeElement);
    $containerEl.stop(true);
    $containerEl.animate({ scrollTop: 0 }, 500);
  }

  onFiltersChanged() {
    this.filtersChanged.emit(this.query);
  }

  onPublicUseChanged() {
    this.publicUseChanged.emit();
  }

  onFuelPriceToggleChanged() {
    this.fuelPriceToggleChanged.emit();
  }

  onClickFuelLearnMore() {
    const dialogRef = this._matDialog.open(ShowDialogComponent);
  }
}
